@if (notifications.length) {
  <div
    class="fixed flex flex-col justify-start items-end pt-[2rem] pr-[2rem] gap-[1rem] notifications-wrapper"
    [class.notifications-wrapper-m]="mobileDesign">
    @for (n of notifications; track n) {
      <div [style.visibility]="n.hidden ? 'hidden' : 'initial'" class="w-[21.875rem] relative flex flex-row items-center gap-[0.625rem] br-0p625 clickable notification-tr">
        <svg class="absolute w-[1.875rem] h-[1.875rem] close-svg"
             [class.icon-size]="mobileDesign"
             (click)="n.hidden = true">
          <use [attr.xlink:href]="'../assets/svg/optimized/close.svg#img'"
               [attr.href]="'../assets/svg/optimized/close.svg#img'"></use>
        </svg>
        <div class="w-[1.875rem] mob-h-[7.5em] mob-w-[7.5em] h-[1.875rem] {{n.type}}"
             [ngClass]="{'mob-h-[7.5em]': mobileDesign, 'mob-w-[7.5em]': mobileDesign}"></div>
        <div class="notification-text-container flex flex-col">
          <div class="font-3 bold500"
               [class.mob-font-5em]="mobileDesign">
            {{n.title}}
          </div>
          <div class="font-4 color"
               [class.mob-font-4em]="mobileDesign">
            {{n.message}}
          </div>
        </div>
      </div>
    }
  </div>
}
